type CapitaliseFirstLetter = (value: string) => string;

export const capitaliseFirstLetter: CapitaliseFirstLetter = value => {
  return value.charAt(0).toUpperCase() + value.slice(1);
};
